import { Controller } from "stimulus"

export default class extends Controller {
  // Navigates to the dictionary edit page when a row is clicked
  // Ignores clicks on action buttons/dropdowns inside the row
  rowClick(event) {
    const row     = event.currentTarget
    const editUrl = row.dataset.dictionaryEditUrl
    if (!editUrl) return

    // Row click navigates to edit, but several child elements have their own behavior.
    // If the click started inside one of these, do not also run row navigation.
    const interactiveElements = event.target.closest(
      '.js-dictionaries-index-actions, .js-dictionaries-index-field-link, button'
    )

    // .js-dictionaries-index-actions — Edit / Sets / More / Delete in the actions column
    // .js-dictionaries-index-field-link — name, year, volume links to the edit page
    // button — any other buttons in the row (e.g. Delete)  
    if (interactiveElements) return

    // Cmd/Ctrl+click opens in a new tab
    if (event.metaKey || event.ctrlKey) {
      window.open(editUrl, '_blank', 'noopener,noreferrer')
      return
    }

    window.location.assign(editUrl)
  }

  moveTo(event) {
    event.preventDefault()
    
    const link = event.currentTarget
    const dictionaryId = link.dataset.dictionaryId
    const targetState = link.dataset.targetState
    
    // Close dropdown using Bootstrap API
    const dropdownElement = link.closest('.dropdown')
    if (dropdownElement) {
      const dropdown = bootstrap.Dropdown.getInstance(dropdownElement.querySelector('[data-bs-toggle="dropdown"]'))
      if (dropdown) dropdown.hide()
    }
    
    // Send AJAX request
    $.ajax({
      url: `/dictionaries/${dictionaryId}/update_dictionary_state`,
      type: 'PATCH',
      data: { state: targetState },
      success: (response) => {
        if (response.success) {
          this.removeCard(dictionaryId)
        } else {
          showFlashMessage(response.error || 'Failed to move dictionary', 'error')
        }
      },
      error: (xhr) => {
        console.error('Error:', xhr)
        showFlashMessage('An error occurred', 'error')
      }
    })
  }

  delete(event) {
    event.preventDefault()
    
    const button = event.currentTarget
    const confirmMessage = button.dataset.confirm
    
    if (!confirm(confirmMessage)) {
      return
    }
    
    const dictionaryId = button.dataset.dictionaryId
    
    // Close dropdown using Bootstrap API
    const dropdownElement = button.closest('.dropdown')
    if (dropdownElement) {
      const dropdown = bootstrap.Dropdown.getInstance(dropdownElement.querySelector('[data-bs-toggle="dropdown"]'))
      if (dropdown) dropdown.hide()
    }
    
    // Send AJAX DELETE request
    $.ajax({
      url: `/dictionaries/${dictionaryId}`,
      type: 'DELETE',
      dataType: 'json',
      success: (response) => {
        if (response.success) {
          this.removeCard(dictionaryId)
        } else {
          showFlashMessage(response.message || 'Failed to delete dictionary', 'error')
        }
      },
      error: (xhr) => {
        console.error('Error:', xhr)
        const errorMessage = xhr.responseJSON?.message || 'Failed to delete dictionary'
        showFlashMessage(errorMessage, 'error')
      }
    })
  }

  removeCard(dictionaryId) {
    const card = document.querySelector(`[data-dictionary-id="${dictionaryId}"]`)
    if (card) {
      card.style.transition = 'opacity 0.3s'
      card.style.opacity = '0'
      setTimeout(() => card.remove(), 300)
    }
  }
}
